module.exports = __webpack_public_path__ + "fonts/Roboto-BlackItalic.c3332e3b.ttf";